module.exports = __webpack_public_path__ + "img/catching_card.09724687.svg";